import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import getCreditCardType from "./getCreditCardType";


const GroheCartCardColumns = (props) => {

  const {cardInfo} = props;

  if (!cardInfo.cardName && !cardInfo.cardNumber) {
    return null
  }

  const getCardNumText = () => {
    const num = cardInfo.cardNumber.replaceAll(/ /g, "");
    if (!num || num.length <= 4) {
      return num
    }

    const lastFourDigits = num.substr(num.length - 4);
    // const xDigits = num.substr(0, num.length - 4).replaceAll(/./g, "X");
    // return xDigits.match(/.{1,4}/g).join(" ") + " " + lastFourDigits
    return lastFourDigits
  }


  return (
    <Fragment>
      <div className="gc-footer__item">
        <span className="gc-footer__item-title">
          <FormattedMessage id="grohe.cart.confirm.columns.card"/>
        </span>
        <div className="gc-footer__item-value bold">
          {getCreditCardType(cardInfo.cardNumber).text + " "}
          <span className="gc-footer__item-spacer">
            <FormattedMessage id="grohe.cart.confirm.columns.cardEnding"/>
          </span>
          {getCardNumText()}
        </div>
      </div>
      <div className="gc-footer__item">
        <span className="gc-footer__item-title">
          <FormattedMessage id="grohe.cart.confirm.columns.cardName"/>
        </span>
        <div className="gc-footer__item-value bold">
          {cardInfo.cardName}
        </div>
      </div>
    </Fragment>
  )
};


const mapStateToProps = (store) => {
  const {cardInfo} = store.paymentState;

  return {
    cardInfo,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartCardColumns))
)
